<template>
  <div class="brutto text-dark" :class="{'brutto--kindergarten': isKindergarten}">
    <button class="do-bttn" @click="setIsNormModal">Normberegning</button>
    <DModal v-if="isActive" :isBgOverlay="true" :showClose="false">
      <div class="brutto-container" slot="insertComponent">
        <div class="brutto-container__header">
          <h2>Normberegning</h2>
          <div class="icon__bg-circle doc-modal__close" @click="close">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="brutto-container__body">
          <div class="brutto-container__body__left">
            <div class="d-tabs">
              <div class="d-tabs__tab" @click="setActiveTab(0)" :class="{'d-tabs__tab--active': getIsActiveTab(0)}">
                Bruttotid
              </div>
              <div class="d-tabs__tab" @click="setActiveTab(1)" :class="{'d-tabs__tab--active': getIsActiveTab(1)}">
                Nettotid
              </div>
            </div>
            <div class="d-tabs__content">
              <AssignHoursNormList
                :standardNettoHours="originalNettoTime"
                :isNetto="activeTab === 1"
                :isKindergarten="isKindergarten"
                :schoolYear="activeSchoolYear"
                :theEditUserNorm="theEditUserNorm"
                @onEditBrutto="setActiveTab(0)"
                @onEditNetto="setActiveTab(1)"
                @updated="setItemsToSave"
                @changedSum="setNettoTime"
                @onEditedStandardWorkingHours="setIsShowNewNettoModal($event)"
                @changedEmploymentRate="onChangedEmploymentRate">
              </AssignHoursNormList>
            </div>
            <div class="more-norms" v-if="!isKindergarten && !isPoolsDeactivated">
              <div class="rest-calculation">
                <label class="d-label">Rest / Ikke fordelt på puljer</label>
                {{ restCalculation }}
              </div>
              <ul class="brutto__items">
                <li v-for="(item, idx) in items" :key="item.id" class="brutto__items__item__container">
                  <div class="label-with-toggle" @click="toggleItem(idx)">
                    <label class="d-label">Indsæt {{ item.name }}</label>
                    <app-toggle :allowChanges="false" :propOn="isItemToggled(idx)"></app-toggle>
                  </div>
                  <div class="brutto__items__item" v-if="isItemToggled(idx)">
                    <span class="norm-title">
                      {{ item.name }}
                      <span class="norm-title__sub"
                            v-if="prepFactor && item.id === 'assigned_preparation_hours'">
                        {{ prepFactor }} Forberedelesfaktor * {{ hoursForTeaching }} UV
                      </span>
                    </span>
                    <div class="d-input-group__input"
                         content='Forberedelse opdateres automatisk ift. hvad der er tildelt i "Undervisning"'
                         v-tippy="{
                      arrow: true,
                      animateFill: false,
                      animation : 'shift-away',
                      zIndex: '999999992',
                      boundary: 'window',
                      onShow: () => isShowPrepFactorTooltip(item)
                    }">
                      <div
                        v-if="isEmploymentRateChanged && (item.id !== 'assigned_preparation_hours' && prepFactor)"
                        class="employment-rate-calculator"
                      >
                        ({{ formatEmploymentRateText(item) }})
                      </div>
                      <span class="label">{{ item.unit ? item.unit : 'timer' }}</span>
                      <input :disabled="prepFactor && item.id === 'assigned_preparation_hours'" type="number"
                             v-model="item.hours" @change="onUpdatingHours(item, $event.target.value)"
                             @focus="$event.target.select()">
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="brutto__items__item__container brutto__items__item__container__notefield"
                 :class="{'brutto__items__item__container__notefield--alone' :isPoolsDeactivated}">
              <div class="label-with-toggle" @click="setIsShowAgreement">
                <label class="d-label">Indsæt en note til de valgte personer</label>
                <app-toggle :allowChanges="false" :propOn="isShowAgreement"></app-toggle>
              </div>
              <AppEIPWYZIWYG
                v-if="isShowAgreement"
                :isKeepOpen="true"
                :is-open="true"
                :isInTestOfSaveButton="false"
                @changed="updateAgreements">
              </AppEIPWYZIWYG>
              <h4 class="text-explainer" v-if="isShowAgreement">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon-archive tw-icon">
                  <path class="primary"
                        d="M5.23 3h13.54a2 2 0 0 1 1.98 2.22l-1.55 14A2 2 0 0 1 17.2 21H6.79a2 2 0 0 1-1.99-1.78l-1.55-14A2 2 0 0 1 5.23 3z"/>
                  <path class="secondary"
                        d="M10.59 14l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 12.58l2.3-2.3a1 1 0 0 1 1.4 1.42L13.42 14l2.3 2.3a1 1 0 0 1-1.42 1.4L12 15.42l-2.3 2.3a1 1 0 1 1-1.4-1.42L10.58 14zM4 3h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5c0-1.1.9-2 2-2z"/>
                </svg>
                Bemærk at hvis der står noget i personens notefelt i forvejen vil dette blive slettet
              </h4>
            </div>
          </div>
          <div class="brutto__users">
            <div class="brutto__users__header">
              <DoFiltersFilter
                :users="usersSortedOnNameWithTags"
                :tags="tags"
                :selectedTags="appliedFilters"
                @clear="appliedFilters = []"
                @select="toggleFilter">
              </DoFiltersFilter>
            </div>
            <div class="norm-select-users__header">
              <div class="text-link" @click="toggleAll">
                {{ selectedUsers.length < 1 ? 'Vælg alle' : 'Fravælg alle' }}
              </div>
              <span> Viser {{ filteredUsers.length }} af {{ usersSortedOnName.length }}</span>
            </div>
            <ul class="brutto__users__list">
              <li class="brutto__users__user"
                  v-for="user in filteredUsers"
                  @click="toggleUser(user)"
                  :class="{'is-selected': getIsUserSelected(user)}"
                  :key="user.id">
                {{ user.name }}
                <div class="icon__bg-circle d-edit-btn" @click.stop="editUserNorm(user)"><span
                  class="icon-wrench"></span></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="brutto-container__footer">
          <button @click="isActive = false">Annullér</button>
          <button class="bttn bttn-primary"
                  :class="[{'bttn-primary--disabled': selectedUsers.length < 1}, {'bttn--loading': isSaving}]"
                  @click="isWarningActive = true"
                  content="Der skal vælges minimum en bruger"
                  v-tippy="{
                    arrow: true,
                    onShow: () => selectedUsers.length < 1
                  }"
          >Gem
          </button>
        </div>
      </div>
    </DModal>
    <DModal v-if="isWarningActive" :isBgOverlay="true" :showClose="false" style="z-index: 999999999">
      <div class="brutto-warning" slot="insertComponent">
        <div class="brutto-warning__header">
          <h2>Gem og erstat?</h2>
          <div class="icon__bg-circle doc-modal__close" @click="isWarningActive = false">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="brutto-warning__body">
          <svg class="tw-icon tw-icon--red" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <p class="text-explainer">
            Du er ved at tildele arbejdstid på {{ nettoTime }} til de valgte brugere. Hvis der i forvejen er tildelt en
            arbejdstid vil dette blive erstattet.
          </p>
        </div>
        <div class="brutto-warning__footer">
          <button @click="isWarningActive = false">Annullér</button>
          <button class="bttn bttn-primary bttn-primary--small" @click="save" :class="[{'bttn--loading': isSaving}]">Gem
            og erstat
          </button>
        </div>
      </div>
    </DModal>
    <ModalConfirmation
      v-if="theNewNettoValue"
      :showClose="false"
      :isShowConfirmDeleteMessage="false"
      @close="setIsShowNewNettoModal(null)">
      <h4 slot="item">Vil du gemme {{ theNewNettoValue }} som den nye standard netto tid på skolen, så du ikke skal
        taste det næste gang?</h4>
      <template slot="confirm_buttons">
        <button class="do-bttn" @click="setIsShowNewNettoModal(null)">
          Ikke gem
        </button>
        <button class="do-bttn do-bttn--submit" ref="submit_bttn"
                @click="saveNewNettoTime">
          Gem som ny standard
        </button>
      </template>
    </ModalConfirmation>
    <ModalConfirmation
      v-if="theNewStandardHoursForPool"
      :showClose="false"
      :isShowConfirmDeleteMessage="false"
      @close="setTheNewStandardHoursForPool(null)">
      <h4 slot="item" style="font-weight: normal;">
        Vil du gemme <span class="bold">{{ theNewStandardHoursForPool.hours }} timer</span> som den nye standard for
        <span class="bold">{{ theNewStandardHoursForPool.name }}-puljen</span>, så du ikke behøver at indtaste det næste
        gang?
      </h4>
      <template slot="confirm_buttons">
        <button class="do-bttn" @click="setTheNewStandardHoursForPool(null)">
          Ikke gem
        </button>
        <button class="do-bttn do-bttn--submit" ref="submit_bttn"
                @click="saveNewStandardHours">
          Gem som ny standard
        </button>
      </template>
    </ModalConfirmation>
    <ModalConfirmation
      v-if="isModalAutoCalculateOpen"
      :showClose="false"
      :isShowConfirmDeleteMessage="false"
      @close="isModalAutoCalculateOpen = false">
      <h4 slot="item" style="font-weight: normal;">
        <h3 class="marg-1-bottom">Skal puljer automatisk opdateres?</h3>
        <ul>
          <li v-for="checkedItem in checkedItemsToUpdate" :key="checkedItem.id">
            <b>{{ checkedItem.name }}:</b> {{ formatEmploymentRateText(checkedItem, true) }}
          </li>
        </ul>
      </h4>
      <template slot="confirm_buttons">
        <button class="do-bttn" @click="isModalAutoCalculateOpen = false">
          Ikke opdatér
        </button>
        <button class="do-bttn do-bttn--submit" ref="submit_bttn"
                @click="updateActivePoolsFromEmploymentRate">
          Opdatér puljer
        </button>
      </template>
    </ModalConfirmation>
  </div>
</template>

<script>
import filterTags from '../Tagging/TaggingFilter'
import DModal from '../common/DModal'
import {mapGetters} from 'vuex'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import AppEIPWYZIWYG from '../common/AppEIPWYZIWYG'
import AppToggle from '../common/AppToggle'
import AssignHoursNormList from './AssignHoursNormList'
import ModalConfirmation from '../Modals/ModalConfirmation.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'

export default {
  components: {DoFiltersFilter, ModalConfirmation, AppToggle, DModal, filterTags, AppEIPWYZIWYG, AssignHoursNormList},
  props: {
    tags: {
      default: () => []
    },
    isKindergarten: {
      type: Boolean,
      default: false
    },
    isLocalPoolActivated: {
      type: Boolean,
      default: false
    },
    prepFactor: {
      default: null
    },
    isPoolsDeactivated: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      theEmploymentRate: 1, // 37/37 == 1
      theNewNettoValue: null,
      isWarningActive: false,
      isActive: false,
      isSaving: false,
      selectedUsers: [],
      appliedFilters: [],
      nettoItems: [],
      items: [
        {id: 'assigned_teaching_hours', name: 'Undervisning', hours: 800, isChecked: false},
        {id: 'assigned_additional_task_hours', name: 'Øvrige opgaver', hours: 400, isChecked: false},
        {id: 'assigned_preparation_hours', name: 'Forberedelse', hours: 400, isChecked: false},
        {id: 'assigned_pool_hours', name: 'Lokalpulje', hours: 80, isChecked: false},
        {id: 'substitute_pool_hours', name: 'Vikartimer', hours: 0, isChecked: false},
        {id: 'assigned_club_hours', name: 'SFO-timer', hours: 0, isChecked: false}
      ],
      originalItems: [],
      agreements: '',
      isShowAgreement: false,
      activeTab: 0,
      itemsToSave: [],
      nettoTime: 1686.1,
      originalNettoTime: 1686.1,
      theEditUserNorm: null,
      theNewStandardHoursForPool: null, // {id: 'assigned_teaching_hours', name: 'Undervisning', hours: 750, isChecked: false},
      isAutoCalculateHoursFromEmploymentRate: false,
      isModalAutoCalculateOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'usersSortedOnName'
    ]),
    schoolSettings () {
      return this.$store.state.schoolSettings
    },
    schoolId () {
      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    restCalculation () {
      const sum = this.items
        .filter(item => item.isChecked)
        .reduce((sum, item) => sum + Number(item.hours), 0)
      return (this.nettoTime - sum).toFixed(2)
    },
    checkedItemsToUpdate () {
      return this.items
        .filter(item => !this.prepFactor || item.id !== 'assigned_preparation_hours')
        .filter(item => item.isChecked)
    },
    isEmploymentRateChanged () {
      return this.isPoolsDeactivated ? false : Number(this.theEmploymentRate) !== 1
    },
    usersSortedOnNameWithTags () {
      return this.usersSortedOnName.map(user => {
        user.tags = user.user_tags
        return user
      })
    },
    filteredUsers () {
      if (!this.appliedFilters.length) return this.usersSortedOnName

      return this.usersSortedOnName.filter(user =>
        user.user_tags && this.appliedFilters.some(filter => user.user_tags.includes(filter))
      )
    },
    hoursForTeaching () {
      const idx = this.items.findIndex(item => item.id === 'assigned_teaching_hours')
      return this.items[idx].hours
    }
  },
  methods: {
    setHoursFromEmploymentRate (itemToUpdate) {
      const idx = this.items.findIndex(item => item.id === itemToUpdate.id)
      if (idx === -1) return // Sikrer, at vi ikke prøver at ændre noget, der ikke findes

      const item = this.items[idx]
      const originalItem = this.findOriginalItem(item)
      const newHours = parseFloat((originalItem.hours * this.theEmploymentRate).toFixed(2)) // Sikrer taltype

      this.$set(this.items, idx, {...item, hours: newHours}) // Vue reagerer korrekt på ændringen
    },
    updateActivePoolsFromEmploymentRate () {
      this.checkedItemsToUpdate.forEach(checkedItem => {
        this.setHoursFromEmploymentRate(checkedItem)
      })
      this.isModalAutoCalculateOpen = false
      this.updatePrepHoursFromTeaching()
    },
    formatEmploymentRateText (item, showResult = false) {
      const originalHours = this.findOriginalItem(item).hours
      const employmentRatePercentage = (this.theEmploymentRate * 100).toFixed(0) + '%'
      const result = (originalHours * this.theEmploymentRate).toFixed(2) // Beregnet resultat

      return showResult
        ? `${originalHours} timer * ${employmentRatePercentage} = ${result} timer`
        : `${originalHours}t * ${employmentRatePercentage}`
    },
    onChangedEmploymentRate (rate) {
      if (this.isPoolsDeactivated) {
        return
      }
      this.theEmploymentRate = rate
      this.isModalAutoCalculateOpen = this.items.some(item => item.isChecked)
    },
    isShowPrepFactorTooltip (item) {
      return item.id === 'assigned_preparation_hours' && this.prepFactor !== null
    },
    saveNewNettoTime () {
      const val = this.theNewNettoValue * 1
      this.$store.dispatch('updateSchoolSettings', {'nettoTime': val})
      this.originalNettoTime = val
      setTimeout(_ => {
        this.setIsShowNewNettoModal(null)
      }, 0)
    },
    setIsShowNewNettoModal (val) {
      this.theNewNettoValue = val
    },
    setTheNewStandardHoursForPool (obj = null) {
      this.theNewStandardHoursForPool = obj
    },
    saveNewStandardHours () {
      const hours = Number(this.theNewStandardHoursForPool.hours)
      const key = this.theNewStandardHoursForPool.id

      this.$store.dispatch('updateSchoolSettings', {[key]: hours})

      const originalItem = this.originalItems.find(item => item.id === this.theNewStandardHoursForPool.id)
      if (originalItem) {
        originalItem.hours = hours
      }
      setTimeout(() => {
        this.setTheNewStandardHoursForPool(null)
      }, 0)
    },
    setIsNormModal () {
      this.theEmploymentRate = 1
      this.updateItemsWithSchoolSettings()
      if (this.schoolSettings && (this.schoolSettings['netto_time'] || this.schoolSettings['nettoTime'])) {
        const nettTime = this.schoolSettings['netto_time'] || this.schoolSettings['nettoTime']
        this.nettoTime = nettTime
        this.originalNettoTime = nettTime
      }
      this.isActive = true
      this.updatePrepHoursFromTeaching()
    },
    updatePrepHoursFromTeaching () {
      if (!this.prepFactor) {
        return
      }
      const thePrep = this.hoursForTeaching * this.prepFactor
      const roundedPrep = parseFloat(thePrep.toFixed(2))
      const idx = this.items.findIndex(hoursItem => hoursItem.id === 'assigned_preparation_hours')
      this.items[idx].hours = roundedPrep
    },
    onUpdatingHours (item, val) {
      const originalItem = this.originalItems.find(item => item.id === item.id)
      const originalVal = originalItem.hours
      const newVal = val * 1
      if (!this.isEmploymentRateChanged && originalVal !== newVal) {
        this.setTheNewStandardHoursForPool(item)
      }
      this.updatePrepHoursFromTeaching()
    },
    findOriginalItem (item) {
      return this.originalItems.find(originalItem => originalItem.id === item.id)
    },
    toggleItem (idx) {
      const item = this.items[idx]
      this.items[idx].isChecked = !this.items[idx].isChecked
      if (this.prepFactor && item.id === 'assigned_preparation_hours') {
        return
      }
      if (this.isEmploymentRateChanged) {
        this.setHoursFromEmploymentRate(item)
        this.updatePrepHoursFromTeaching()
      }
    },
    isItemToggled (idx) {
      return this.items[idx].isChecked
    },
    setNettoTime (time) {
      this.nettoTime = time
    },
    setItemsToSave (arr) {
      this.itemsToSave = arr
    },
    setActiveTab (num) {
      this.activeTab = num
      if (num === 1) {
        this.nettoTime = this.originalNettoTime
      }
    },
    getIsActiveTab (num) {
      return this.activeTab === num
    },
    setIsShowAgreement () {
      this.isShowAgreement = !this.isShowAgreement
    },
    toggleAll () {
      if (this.selectedUsers.length > 0) {
        this.selectedUsers = []
      } else {
        this.selectedUsers = []
        this.filteredUsers.forEach(user => this.selectedUsers.push(user.id))
      }
    },
    getIsUserSelected (user) {
      const idx = this.selectedUsers.findIndex(selectedUser => selectedUser === user.id)
      return idx > -1
    },
    toggleUser (user) {
      const idx = this.selectedUsers.findIndex(selectedUser => selectedUser === user.id)
      if (idx > -1) {
        this.selectedUsers.splice(idx, 1)
      } else {
        this.selectedUsers.push(user.id)
      }
    },
    toggleFilter (tag) {
      this.selectedUsers = []
      const idx = this.appliedFilters.findIndex(filter => filter === tag) // Rettet her

      if (idx < 0) {
        this.appliedFilters.push(tag)
      } else {
        this.appliedFilters.splice(idx, 1)
      }
    },
    close () {
      this.isActive = false
      this.selectedUsers = []
    },
    save () {
      if (this.selectedUsers.length < 1) {
        return
      }

      function validateNumber (item) {
        const itemsNotToValidate = ['hidden_ansættelsesgrad', 'Periode', 'hidden_periode_start', 'hidden_periode_end', 'Ansættelsesgrad']
        if (itemsNotToValidate.indexOf(item.title) > -1) {
          return item.value
        } else {
          const val = item.hours * 1
          return val.toFixed(2)
        }
      }

      this.isSaving = true
      const itemsToSave = this.itemsToSave.map(item => {
        return {
          title: item.title,
          value: validateNumber(item)
        }
      })
      itemsToSave.push({title: 'Arbejdstid', value: this.nettoTime})
      const data = {
        norm: itemsToSave,
        assigned_total_hours: this.nettoTime
      }
      if (this.isShowAgreement) {
        data['agreements'] = this.agreements
      }
      const activatedItems = this.items.filter(item => item.isChecked)
      activatedItems.forEach(item => {
        data[item.id] = item.hours
      })
      // [{user_id: 1, data: {}}, {user_id: 2, data: {}}]
      const dataToSave = this.selectedUsers.map(userId => {
        return {
          user_id: userId,
          data: data
        }
      })
      docendo.bulkSchoolUserYearUpdate(this.schoolId, this.activeSchoolYear.name, dataToSave, success => {
        this.reset()
        this.$emit('updateUsersHours')
        this.close()
        eventbus.toast = {text: 'Gemt', 'success': true}
      }, failure => {
        eventbus.toast = {text: 'Noget gik galt', 'success': false}
      })
    },
    reset () {
      this.isSaving = false
      this.selectedUsers = []
      this.isShowAgreement = false
      this.agreements = ''
      this.items = JSON.parse(JSON.stringify(this.originalItems))
      this.isWarningActive = false
    },
    updateAgreements (val) {
      this.agreements = val
    },
    readUserNorm (user) {
      docendo.schoolUserYearRead(this.schoolId, user.id, this.activeSchoolYear.name, success => {
        this.theEditUserNorm = success.norm ? success.norm : []
        this.userAgreements = success.agreements ? success.agreements : ''
      }, failure => {
        console.log('failed!')
      })
    },
    editUserNorm (user) {
      this.readUserNorm(user)
    },
    updateItemsWithSchoolSettings () {
      this.items.forEach(item => {
        const setting = this.schoolSettings && this.schoolSettings[item.id]
        if (setting) {
          this.$set(item, 'hours', setting) // Sikrer at Vue registrerer ændringen
        }
      })
      this.originalItems.forEach(item => {
        const setting = this.schoolSettings && this.schoolSettings[item.id]
        if (setting) {
          this.$set(item, 'hours', setting) // Sikrer at Vue registrerer ændringen
        }
      })
    }
  },
  beforeMount () {
    if (!this.isLocalPoolActivated) {
      const idx = this.items.findIndex(item => item.id === 'assigned_pool_hours')
      this.items.splice(idx, 1)
    }
  },
  mounted () {
    this.originalItems = JSON.parse(JSON.stringify(this.items))
  }
}
</script>

<style>
@import '../../assets/css/variables.css';

.brutto {
  position: relative;
}

.brutto input[type="number"] {
  background: #ffffff;
}

.brutto-container {
  background: #fff;
  border-radius: 4px;
}

.brutto-container__header {
  padding: 1rem;
  border-bottom: 1px solid #dddddd;
}

.brutto-container__body {
  display: flex;
  background: var(--bg-grey);
  min-height: 65vh;
  max-height: calc(100vh - (52px + 53px));
  overflow-y: auto;
  overscroll-behavior: contain;
}

.brutto-container__body__left {
  width: 500px;
  border-right: 1px solid #dddddd;
  padding: 1rem;
}

.brutto__items {
  margin: 0;
  padding: 1rem;
  font-weight: normal;
}

.brutto__users {
  width: 400px;
}

.brutto__items__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.brutto__items__item.brutto__items__item--netto-hours {
  margin-bottom: 0;
}


.norm-title, .norm-title + label {
  user-select: none;
}

.brutto__items__item > input[type="text"],
.brutto__items__item > input[type="number"],
.brutto__items__item > input[type="range"] {
  width: 150px;
  font-weight: normal;
  padding: 0;
}

.brutto__items__item input[type="number"]:not([disabled]) {
  background: #ffffff;
}

.brutto__items__item input[type="number"] {
  width: 100px;
}

.brutto__items__item .d-input-group {
  display: flex;
  align-items: center;
}

.brutto__items__item .d-input-group label {
  margin-right: 2px;
}

.brutto-container__footer {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #dddddd;
}

.brutto-container__footer > .bttn:last-child {
  margin-left: 1rem;
}

.brutto__users__header {
  border-bottom: 1px solid #dddddd;
  padding: 1rem;
}

.brutto__users__user {
  position: relative;
  display: flex;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  transition: background-color 0.15s, transform 0.25s;
}

.brutto__users__user:hover {
  background-color: aliceblue;
}

.brutto__users__user:active {
  transform: scale(0.98);
}

.brutto__users__user:before {
  content: '';
  font-family: 'icomoon' !important;
  color: #ffffff;
  display: flex;
  font-size: 9px;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin-right: 0.5rem;
  cursor: pointer;
  transition: background-color 0.15s;
}

.brutto__users__user.is-selected:before {
  content: '\ED72';
  background-color: var(--blue);
  border-color: var(--blue);
}

.brutto__users__list {
  max-height: 65vh;
  overflow: auto;
}

.d-input-group__input {
  display: flex;
  align-items: center;
  font-weight: normal;
}

.d-input-group__input span {
  margin-right: 5px;
  font-size: 0.85rem;
}

.brutto__items__item__netto {
  margin-top: 2rem;
}

.norm-select-users__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  padding: 0.25rem 1rem;
  font-weight: normal;
}

.brutto__users__list__header {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-weight: normal;
  font-size: 0.9rem;
  user-select: none;
  transition: transform 0.25s;
}

.brutto__users__list__header:hover {
  color: var(--blue);
}

.brutto__users__list__header:active {
  transform: scale(0.98);
}

.bttn-primary.bttn-primary--disabled {
  opacity: 0.65;
  cursor: not-allowed;
  box-shadow: none !important;
}

.bttn.bttn-primary.bttn--loading:before {
  border: 3px solid #ffffff;
  border-left: 3px solid transparent;
  pointer-events: none;
}

.user-agreements__notefield {
  font-weight: normal;
  border-top: 1px solid #ddd;
  padding: 1rem 0 2rem 0;
  margin-top: 2rem;
}

.user-agreements__notefield__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 0;
}

.user-agreements__notefield__header label.d-label {
  margin-left: 0.5rem;
  line-height: 1;
}

.tw-icon {
  width: 16px;
}

.tw-icon .secondary {
  fill: #0D2B3E;
}

.tw-icon .primary {
  fill: #A5B3BB;
}

h4.text-explainer {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: normal;
  margin-top: 0.5rem;
}

h4.text-explainer svg {
  margin-right: 5px;
}

.brutto-warning {
  width: 350px;
  border-radius: 4px;
}

.brutto-warning__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 1rem;
  border-bottom: 1px solid #dddddd;
  border-radius: 4px 4px 0 0;
}

.brutto-warning__body {
  padding: 1rem;
}

.brutto-warning__footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-radius: 0 0 4px 4px;
}

.brutto-warning__footer button {
  margin-left: 1rem;
}

.bttn.bttn-primary.bttn-primary--small {
  padding: 2px 1rem;
}

.tw-icon.tw-icon--red {
  color: #ef4746;
}

.d-tabs {
  display: flex;
}

.d-tabs__tab {
  border: 1px solid transparent;
  border-bottom: 0;
  padding: 0.5rem;
  border-radius: 4px 4px 0 0;
  margin-right: 0.5rem;
  margin-bottom: -1px;
  cursor: pointer;
}

.d-tabs__tab.d-tabs__tab--active {
  border-color: #dddddd;
  background: #edf0f5;
}

.d-tabs__content {
  border: 1px solid #dddddd;
  padding: 1rem;
  border-radius: 0 4px 4px 4px;
}

.norm-title {
  font-weight: bold;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.norm-title__sub {
  font-weight: lighter;
  font-size: 11px;
}

.label-with-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border-radius: 4px;
  margin: 0 -0.5rem;
  cursor: pointer;
  transition: 0.15s ease;
}

.label-with-toggle label {
  cursor: pointer;
}

.label-with-toggle:hover {
  background: aliceblue;
}

.brutto__items__item__container {
  border: 1px solid #dddddd;
  padding: 0.5rem 1rem;
  margin: 0 -1rem 1rem -1rem;
  border-radius: 4px;
}

.brutto__items__item__container .brutto__items__item {
  margin-top: 0.5rem;
}

.brutto__items__item__container__notefield {
  margin: -1rem 0;
  font-weight: normal;
}

.brutto__items__item__container__notefield.brutto__items__item__container__notefield--alone {
  margin: 1rem 0;
}

.brutto--kindergarten .brutto__items__item__container__notefield {
  margin: 1rem 0;
}

.brutto__users__user:hover .d-edit-btn {
  opacity: 1;
}

.d-edit-btn {
  opacity: 0;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.d-input-group__input > input[type="number"][disabled] {
  background: #eeeeee;
  cursor: not-allowed;
}

.employment-rate-calculator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 0.5rem;
}

.rest-calculation {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 1rem 0;
  margin-bottom: -0.5rem;
}

.rest-calculation label.d-label {
  margin-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// AssignHoursNorm.vue?5f746ac5